<template>
    <mdb-col sm="4" class="col-no-left-pad ">
        <mdb-card>
          <mdb-card-body>
            <!--<mdb-card-title>Twitter</mdb-card-title>-->
            <mdb-card-text v-html="twitter_feed" id="crdtxt"> </script></mdb-card-text>            
          </mdb-card-body>
        </mdb-card>
    </mdb-col>

</template>

<script>
import {CONTENT_DOMAIN} from '@/constants/general_constants';
import axios from 'axios';
import { mdbCard, mdbCardBody, mdbCardTitle, mdbCardText, mdbRow, mdbCol } from 'mdbvue';
  
export default {
    name: 'TwitterFeed',
    data() {
        return {
            twitter_feed: '<a class="twitter-timeline" href="https://twitter.com/WorkplaceOption?ref_src=twsrc%5Etfw">Tweets by WorkplaceOption</a>',
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN
           
        };
                
    },
    components: {
            mdbCard,
            mdbCardBody,
            mdbCol,
            mdbRow,
            mdbCardTitle,
            mdbCardText
           
        },
    mounted :function(){
        this.showTwitterFeed()
         
        },
    methods:{
        showTwitterFeed(){ 
            axios.get(this.$store.state.apiUrl+'/rss_feed',{
                params:{
                    
                    id_company:this.$store.state.companyData['id_company']                    
                }
            })
            .then(response => {
                response = response.data
                //console.log(response);
                this.twitter_feed = response.alink;
                this.loadExternalScript(response.scriptsrc)       
                this.$nextTick(function () {
                    
                })
            
            })
            .catch(() => {
                this.twitter_feed = '';
            });
        },
        loadExternalScript(path_to_file){
            //console.log('calling create scr wow');
            const plugin = document.createElement("script");
            plugin.setAttribute(
            "src",
            path_to_file
            );
            plugin.async = true;
            //document.body.appendChild(plugin);
            document.getElementById("crdtxt").appendChild(plugin);
        }
    }
}
</script>

<style scoped>
    .badge-color {
        background-color: #67676791 !important;
        margin: 0px 5px 6px 0;
    }
    .col-no-left-pad{
        padding-left: 0px;
        padding-right: 0px;
    }
    .col-no-right-pad{
        padding-right: 0px;
    }
</style>